"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconButton = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var clsx_1 = __importDefault(require("clsx"));
var colors_1 = require("../colors");
var useStyles = (0, styles_1.makeStyles)(function () { return ({
    base: function (props) {
        var _a, _b, _c, _d;
        return ({
            alignItems: 'center',
            backgroundColor: (0, colors_1.getColor)(props.backgroundColor),
            border: 'none',
            borderRadius: '50px',
            boxShadow: "".concat(props.withShadow ? '0px 3px 7px rgba(0, 0, 0, 0.2)' : 'none'),
            color: (0, colors_1.getColor)(props.color),
            cursor: 'pointer',
            display: 'flex',
            justifyContent: 'center',
            height: props.size ? "".concat(props.size, "px") : "".concat(props.height, "px"),
            width: props.size ? "".concat(props.size, "px") : "".concat(props.width, "px"),
            '&:active': {
                // in case active styles are not provided - fallback to default styles
                backgroundColor: (0, colors_1.getColor)(((_a = props.activeStyles) === null || _a === void 0 ? void 0 : _a.backgroundColor) || props.backgroundColor),
                color: (0, colors_1.getColor)(((_b = props.activeStyles) === null || _b === void 0 ? void 0 : _b.color) || props.color),
            },
            '&:disabled': {
                // in case disabled styles are not provided - fallback to default styles
                backgroundColor: (0, colors_1.getColor)(((_c = props.disabledStyles) === null || _c === void 0 ? void 0 : _c.backgroundColor) || props.backgroundColor),
                color: (0, colors_1.getColor)(((_d = props.disabledStyles) === null || _d === void 0 ? void 0 : _d.color) || props.color),
                cursor: 'not-allowed',
            },
        });
    },
}); });
var IconButton = function (_a) {
    var className = _a.className, disabled = _a.disabled, icon = _a.icon, onClick = _a.onClick, stylesProps = _a.stylesProps;
    var classes = useStyles(stylesProps);
    if (!((stylesProps === null || stylesProps === void 0 ? void 0 : stylesProps.size) || ((stylesProps === null || stylesProps === void 0 ? void 0 : stylesProps.height) && (stylesProps === null || stylesProps === void 0 ? void 0 : stylesProps.width))) &&
        ((stylesProps === null || stylesProps === void 0 ? void 0 : stylesProps.size) || !((stylesProps === null || stylesProps === void 0 ? void 0 : stylesProps.height) && (stylesProps === null || stylesProps === void 0 ? void 0 : stylesProps.width)))) {
        console.error("No size or height and width");
    }
    return (react_1.default.createElement("button", { className: (0, clsx_1.default)(classes.base, className), disabled: disabled || false, onClick: onClick, type: 'button' }, icon));
};
exports.IconButton = IconButton;
